var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoAppt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 7.44313C18.3333 6.93829 18.3333 6.68586 18.2335 6.56898C18.1468 6.46756 18.0169 6.41373 17.8839 6.4242C17.7307 6.43626 17.5522 6.61475 17.1952 6.97173L14.1666 10.0003L17.1952 13.0289C17.5522 13.3859 17.7307 13.5644 17.8839 13.5765C18.0169 13.5869 18.1468 13.5331 18.2335 13.4317C18.3333 13.3148 18.3333 13.0624 18.3333 12.5575V7.44313Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 8.16699C1.66663 6.76686 1.66663 6.0668 1.93911 5.53202C2.17879 5.06161 2.56124 4.67916 3.03165 4.43948C3.56643 4.16699 4.26649 4.16699 5.66663 4.16699H10.1666C11.5668 4.16699 12.2668 4.16699 12.8016 4.43948C13.272 4.67916 13.6545 5.06161 13.8941 5.53202C14.1666 6.0668 14.1666 6.76686 14.1666 8.16699V11.8337C14.1666 13.2338 14.1666 13.9339 13.8941 14.4686C13.6545 14.939 13.272 15.3215 12.8016 15.5612C12.2668 15.8337 11.5668 15.8337 10.1666 15.8337H5.66663C4.26649 15.8337 3.56643 15.8337 3.03165 15.5612C2.56124 15.3215 2.17879 14.939 1.93911 14.4686C1.66663 13.9339 1.66663 13.2338 1.66663 11.8337V8.16699Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoAppt);
export default __webpack_public_path__ + "static/media/VideoAppt.4cf115179dc2f1c097c129a612bb6e28.svg";
export { ForwardRef as ReactComponent };